import { useEffect, useMemo, useRef } from 'react';
import debounce from 'transmute/debounce';
export default function useDebounce(interval, fn) {
  const funcRef = useRef(fn);
  funcRef.current = fn;
  const debouncedFn = useMemo(() => debounce(interval, (...args) => funcRef.current(...args)), [interval]);
  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);
  return debouncedFn;
}